import { useEffect } from "react";
import { useStores } from "stores/setup/use-store";

/**
 * Hook to manage Rainbow AI radar data fetching and refresh.
 *
 * Fetches metadata when radar is shown and sets up 10-minute refresh interval.
 * Cleans up interval when radar is hidden or component unmounts.
 */
const useRadarData = () => {
  const {
    dataStores: { radarMapStore },
  } = useStores();

  useEffect(() => {
    if (radarMapStore.showRadar) {
      // T015: Fetch Rainbow AI metadata when radar is shown
      radarMapStore.fetchMetadata();

      // T016: Set up 10-minute (600000ms) refresh interval
      const interval = setInterval(() => {
        radarMapStore.fetchMetadata();
      }, 600000); // 10 minutes

      // T017: Cleanup interval on unmount or when radar is hidden
      return () => {
        clearInterval(interval);
      };
    } else {
      // Stop animation when radar is hidden
      radarMapStore.stop();
    }
  }, [radarMapStore.showRadar]);

  return null;
};

export default useRadarData;
